module.exports = __webpack_public_path__ + "static/5-formation-deformation-s-iv-a1b4dad42f3f9ce941aa22f2dd75d1cb.jpg";